const euroFormatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

/**
 * Format an amount as euros in Spanish locale, e.g. `formatEuro(55)` → "55,00 €".
 * Used for StoredValue ("saldo en €") across the app.
 */
export function formatEuro(amount: number): string {
    return euroFormatter.format(amount ?? 0);
}
